import { ButtonMenuItem, TrashIcon } from '@hprofits/ui';

import { t } from '@/i18n';

export const buildMenuItemDelete = ({
  disabled,
  onClick,
}: {
  disabled?: boolean;
  onClick: () => void;
}): ButtonMenuItem => ({
  label: t('modules.common.delete'),
  icon: TrashIcon,
  variant: 'danger',
  disabled,
  onClick,
});
